import React, { useEffect, useState } from "react";
import {
  Modal,
  Text,
  Box,
  Table,
  createStyles,
  Loader,
  Skeleton,
  Tooltip,
} from "@mantine/core";
import { useSelector } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import TableLoader from "../../../components/TableLoader";
import { decrypt } from "../../../utils";
import MonthlyReportHtml from "../../../components/MonthlyReportHtml";
// import TableLoader from "../../../components/TableLoader";
// import { getMar } from "../../../services";
// import defaultImage from "./../../../images/personal2.png";
// import { decrypt } from "../../../utils";
// import Cuations from "../Medication/Cuations";

const TaskViewReportModal = ({
  selectedClient,
  monthValue,
  opened,
  onClose,
  decryptdata,
  facilityName: facilityNameProp,
  facilityPhoto,
  selectedTaskTypeIds = [],
  taskTypeName: taskTypeNameProp,
  servicePlanFieldIds = null,
}) => {
  const { classes } = useStyles();
  // const { tasks, loadingTasks } = useSelector((state) => state?.task);
  const { allTasks, loadingTasks } = useSelector((state) => state?.task);
  const [pdfLoading, setPDFLoading] = useState(false);
  const [taskItems, setTaskItems] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const { allSignature } = useSelector((state) => state?.signature);

  // date formating function
  const today = new Date();
  const formattedDate = `${
    today.getMonth() + 1
  }-${today.getDate()}-${today.getFullYear()}`;
  const reportName = `${formattedDate}_Task_Report`;

  const start = moment(monthValue?.[0]).clone().startOf("day");
  let end;
  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    end = moment(monthValue?.[monthValue?.length - 1])
      .add(1, "M")
      .clone()
      .startOf("day");
  } else {
    end = moment(monthValue?.[monthValue?.length - 1])
      .endOf("month")
      .clone()
      .startOf("day");
  }

  const datesArray = [];
  let currentDate = start;

  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    while (currentDate < end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  } else {
    while (currentDate <= end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  }

  const daysArray = datesArray.map((date) => date.format("ddd"));

  // Decrypt allTasks reactively so we always use the latest data from Redux
  const decryptedTasks = React.useMemo(() => {
    if (!allTasks) return null;
    try {
      const result = decrypt(allTasks);
      return result || allTasks;
    } catch {
      return allTasks;
    }
  }, [allTasks]);

  // Clear state when modal closes so stale data doesn't persist
  useEffect(() => {
    if (!opened) {
      setTaskItems([]);
      setStaffs([]);
    }
  }, [opened]);

  useEffect(() => {
    // Don't process while API is still loading
    if (!opened || loadingTasks) return;

    const sourceData = decryptedTasks || decryptdata;
    if (!sourceData) return;

    // Normalize selectedTaskTypeIds to always be an array
    const typeIds = Array.isArray(selectedTaskTypeIds)
      ? selectedTaskTypeIds
      : selectedTaskTypeIds ? [selectedTaskTypeIds] : [];

    // find client related tasks, filtered by selected task types
    let filteredTasks = sourceData?.filter(
      (taskItem) =>
        taskItem?.client?.id === selectedClient?.id &&
        (typeIds.length === 0 || typeIds.includes(taskItem?.taskType?.id)),
    );

      // sort tasks
      filteredTasks = filteredTasks.sort(
        (a, b) => new Date(a.dateTime) - new Date(b.dateTime),
      );
      const items = [];
      let staffs = [];
      filteredTasks?.flatMap((taskItem) => {
        return (
          taskItem.taskType?.subTasks?.map((subTask) => {
            const taskName = subTask?.task;

            const indexOfTaskTypeAndTask = items?.findIndex(
              (_i) =>
                _i?.taskTypeId === taskItem?.taskType?.id &&
                _i?.taskId === taskName?._id,
            );

            let fields = [];

            // Only include fields that were actually checked in this task
            const applicableFields = subTask?.fields?.filter((field) =>
              taskItem?.fieldsDone?.some((_fd) => _fd?.field?._id === field?._id)
            );

            applicableFields?.map((field) => {
              let isChecked = taskItem?.fieldsDone?.filter(
                (_fd) => _fd?.field?._id === field?._id,
              )?.[0];
              staffs.push(
                isChecked?.staff?.name
                  ? {
                      name: isChecked?.staff?.name,
                      id: isChecked?.staff?.id,
                    }
                  : undefined,
              );
              fields.push({
                id: field._id,
                name: field.name,
                isChecked: isChecked,
              });
            });

            const taskDateStr = moment(taskItem?.dateTime).format("YYYY-MM-DD");

            if (indexOfTaskTypeAndTask === -1) {
              // New group — build full date_array for every field
              const updated_fields = fields?.map((field) => ({
                ...field,
                date_array: datesArray.map((date) => {
                  const dateStr = moment(date).format("YYYY-MM-DD");
                  return {
                    isChecked: (field?.isChecked?.checkedAt && dateStr === taskDateStr)
                      ? [field?.isChecked]
                      : [],
                    date: dateStr,
                    fieldName: field?.name,
                  };
                }),
              }));

              items.push({
                taskTypeId: taskItem.taskType?.id,
                taskId: taskName?._id,
                taskName: taskName?.name,
                fields: updated_fields,
                taskType: taskItem.taskType?.name,
              });
            } else {
              // Existing group — merge each checked field into it
              fields.forEach((field) => {
                if (!field?.isChecked?.checkedAt) return;

                const index_of_field = items[indexOfTaskTypeAndTask]?.fields?.findIndex(
                  (_v) => _v?.id === field?.id
                );

                if (index_of_field === -1) {
                  // Field not seen before in this group — add it with full date_array
                  items[indexOfTaskTypeAndTask].fields.push({
                    ...field,
                    date_array: datesArray.map((date) => {
                      const dateStr = moment(date).format("YYYY-MM-DD");
                      return {
                        isChecked: dateStr === taskDateStr ? [field?.isChecked] : [],
                        date: dateStr,
                        fieldName: field?.name,
                      };
                    }),
                  });
                } else {
                  // Field exists — update the entry for this task's date
                  const date_array_index = items[indexOfTaskTypeAndTask].fields[
                    index_of_field
                  ]?.date_array?.findIndex((_v) => _v?.date === taskDateStr);

                  if (date_array_index !== -1) {
                    items[indexOfTaskTypeAndTask].fields[index_of_field].date_array[
                      date_array_index
                    ] = {
                      isChecked: [
                        ...(items[indexOfTaskTypeAndTask].fields[index_of_field]
                          .date_array[date_array_index]?.isChecked || []),
                        field?.isChecked,
                      ],
                      date: taskDateStr,
                      fieldName: field?.name,
                    };
                  } else {
                    items[indexOfTaskTypeAndTask].fields[index_of_field].date_array.push({
                      isChecked: [field?.isChecked],
                      date: taskDateStr,
                      fieldName: field?.name,
                    });
                  }
                }
              });
            }
          }) || []
        );
      });
      setTaskItems(items);
      setStaffs([
        ...new Map(
          staffs.filter((_v) => _v).map((item) => [item.id, item]),
        ).values(),
      ]);
  }, [opened, decryptedTasks, decryptdata, selectedTaskTypeIds, loadingTasks, servicePlanFieldIds]);

  /* Second useEffect removed — the first useEffect now handles both
     decryptdata (prop) and decryptedTasks (from Redux allTasks) */

  const downloadPDF = async () => {
    setPDFLoading(true);
    try {
      const container = document.querySelector("[data-pdf-month='all']");
      if (!container) {
        setPDFLoading(false);
        return;
      }

      const targetWidth = 1400;
      const pageW = 279.4;
      const pageH = 215.9;
      const margin = 5;
      const usableW = pageW - margin * 2;
      const usableH = pageH - margin * 2;
      const facLabel = container.dataset.facilityName || reportName || "Report";

      const canvas = await html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        width: targetWidth,
        windowWidth: targetWidth,
        backgroundColor: "#ffffff",
        scrollX: 0,
        scrollY: 0,
        onclone: (clonedDoc) => {
          clonedDoc.querySelectorAll("img").forEach((img) => {
            img.style.display = "block";
          });
          const cloned = clonedDoc.querySelector("[data-pdf-month='all']");
          if (cloned) {
            cloned.style.width = targetWidth + "px";
            cloned.style.maxWidth = "none";
            cloned.style.overflow = "visible";
          }
        },
      });

      const imgData = canvas.toDataURL("image/png");
      const scaleFactor = usableW / canvas.width;
      const imgTotalH = canvas.height * scaleFactor;
      const totalPages = Math.ceil(imgTotalH / usableH);

      const pdf = new jsPDF("landscape", "mm", "letter");
      let yOffset = 0;
      let pageNum = 1;

      while (yOffset < imgTotalH) {
        if (pageNum > 1) pdf.addPage("letter", "landscape");

        pdf.addImage(imgData, "PNG", margin, margin - yOffset, usableW, imgTotalH);

        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, pageH - margin, pageW, margin + 1, "F");
        pdf.rect(0, 0, pageW, margin, "F");

        pdf.setFontSize(7);
        pdf.setTextColor(160, 160, 160);
        pdf.text(
          `${facLabel} \u00B7 Confidential \u2014 Report generated by Ogiso`,
          margin + 2,
          pageH - margin + 3,
        );
        pdf.text(
          `Page ${pageNum} of ${totalPages}`,
          pageW - margin - 2,
          pageH - margin + 3,
          { align: "right" },
        );

        yOffset += usableH;
        pageNum++;
      }

      pdf.save(`${reportName}.pdf`);
    } catch (err) {
      console.error("PDF export failed", err);
    } finally {
      setPDFLoading(false);
    }
  };

  const getInitials = (name, id, isExcel = false) => {
    const findSign = allSignature.find(
      (item) =>
        (item?.staff && item.staff?.id === id) ||
        (item?.admin && item.admin?.id === id),
    );
    if (decrypt(findSign?.signatureInitials) && !isExcel) {
      return (
        <img
          src={decrypt(findSign?.signatureInitials)}
          height={20}
          alt=""
          crossOrigin="anonymous"
          style={{
            display: "inline-block",
          }}
        />
      );
    } else if (findSign?.signatureInitialsText && !isExcel) {
      return (
        <Text fz={20} fw={400} ff="Island Moments" color="#171717">
          {findSign?.signatureInitialsText}
        </Text>
      );
    } else {
      return (
        <Text span fw={400}>
          {name
            ?.split(" ")
            ?.map((word) => word?.charAt(0).toUpperCase())
            ?.join("")}
        </Text>
      );
    }
  };

  return (
    <>
      <Modal
        centered
        size="95%"
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={onClose}
        styles={{
          header: { width: "100%" },
          body: { overflowX: "auto", padding: 0 },
        }}
        overlayProps={{ blur: 3 }}
      >
        <>
          <Box className={classes.exportBtn}>
            <Tooltip label="Download Excel" position="bottom" withArrow>
              <Box style={{ position: "relative", cursor: loadingTasks ? "not-allowed" : "pointer", opacity: loadingTasks ? 0.5 : 1 }}>
                <ReactHTMLTableToExcel
                  table="excelTaskTable"
                  loading={loadingTasks}
                  disabled={loadingTasks}
                  sheet={reportName}
                  id="test-table-xls-button"
                  filename={`${reportName}`}
                  className="download-table-xls-button"
                  buttonText={
                    <Box style={{ width: 44, height: 50, position: "relative", cursor: "pointer" }}>
                      <svg viewBox="0 0 44 50" width="44" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* File body */}
                        <path d="M4 2C4 0.9 4.9 0 6 0H30L42 12V46C42 47.1 41.1 48 40 48H6C4.9 48 4 47.1 4 46V2Z" fill="#fff" stroke="#16a34a" strokeWidth="1.5"/>
                        {/* Folded corner */}
                        <path d="M30 0L42 12H32C30.9 12 30 11.1 30 10V0Z" fill="#dcfce7" stroke="#16a34a" strokeWidth="1"/>
                        {/* Table lines */}
                        <rect x="10" y="18" width="26" height="2" rx="1" fill="#16a34a" opacity="0.5"/>
                        <rect x="10" y="23" width="26" height="2" rx="1" fill="#16a34a" opacity="0.35"/>
                        <rect x="10" y="28" width="18" height="2" rx="1" fill="#16a34a" opacity="0.25"/>
                        {/* XLS label */}
                        <rect x="2" y="34" width="26" height="14" rx="2" fill="#16a34a"/>
                        <text x="15" y="44" textAnchor="middle" fill="#fff" fontSize="9" fontWeight="700" fontFamily="Arial, sans-serif">XLS</text>
                      </svg>
                    </Box>
                  }
                />
              </Box>
            </Tooltip>

            <Tooltip label="Download PDF" position="bottom" withArrow>
              <Box
                onClick={pdfLoading || loadingTasks ? undefined : downloadPDF}
                style={{ width: 44, height: 50, position: "relative", cursor: pdfLoading || loadingTasks ? "not-allowed" : "pointer", marginLeft: 10, display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                {pdfLoading ? (
                  <Loader size={28} color="#dc2626" />
                ) : (
                  <svg viewBox="0 0 44 50" width="44" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {/* File body */}
                    <path d="M4 2C4 0.9 4.9 0 6 0H30L42 12V46C42 47.1 41.1 48 40 48H6C4.9 48 4 47.1 4 46V2Z" fill="#fff" stroke="#dc2626" strokeWidth="1.5"/>
                    {/* Folded corner */}
                    <path d="M30 0L42 12H32C30.9 12 30 11.1 30 10V0Z" fill="#fef2f2" stroke="#dc2626" strokeWidth="1"/>
                    {/* Document lines */}
                    <rect x="10" y="18" width="26" height="2" rx="1" fill="#dc2626" opacity="0.5"/>
                    <rect x="10" y="23" width="26" height="2" rx="1" fill="#dc2626" opacity="0.35"/>
                    <rect x="10" y="28" width="18" height="2" rx="1" fill="#dc2626" opacity="0.25"/>
                    {/* PDF label */}
                    <rect x="2" y="34" width="26" height="14" rx="2" fill="#dc2626"/>
                    <text x="15" y="44" textAnchor="middle" fill="#fff" fontSize="9" fontWeight="700" fontFamily="Arial, sans-serif">PDF</text>
                  </svg>
                )}
              </Box>
            </Tooltip>
          </Box>
          {loadingTasks ? (
            <Box style={{ display: "flex", justifyContent: "center", padding: 40 }}>
              <Loader size={30} />
            </Box>
          ) : (
            <Box style={{ overflowX: "auto", maxWidth: "100%" }}>
              <MonthlyReportHtml
                data={taskItems}
                datesArray={datesArray}
                selectedClient={selectedClient}
                monthValue={monthValue}
                staffs={staffs}
                getInitials={getInitials}
                facilityName={facilityNameProp}
                facilityPhoto={facilityPhoto}
                allSignature={allSignature}
                decryptFn={decrypt}
                taskTypeName={taskTypeNameProp || (typeof taskItems?.[0]?.taskType === "string" ? taskItems[0].taskType : taskItems?.[0]?.taskType?.name)}
              />
            </Box>
          )}
          {/* Hidden single-table for Excel export — all header + data in one <table> */}
          <div style={{ display: "none" }}>
            <ExcelFullTable
              data={taskItems}
              datesArray={datesArray}
              monthValue={monthValue}
              selectedClient={selectedClient}
              staffs={staffs}
              getInitials={getInitials}
              facilityName={facilityNameProp}
              taskTypeName={taskTypeNameProp}
            />
          </div>
        </>
      </Modal>

      <PDFTaskTableComponent
        loading={loadingTasks}
        daysArray={daysArray}
        datesArray={datesArray}
        monthValue={monthValue}
        selectedClient={selectedClient}
        data={taskItems}
        staffs={staffs}
        getInitials={getInitials}
        facilityName={facilityNameProp}
        facilityPhoto={facilityPhoto}
        allSignature={allSignature}
        decryptFn={decrypt}
        taskTypeName={taskTypeNameProp}
      />
    </>
  );
};

const SignatureImage = ({ url }) => {
  const [base64, setBase64] = useState(null);

  useEffect(() => {
    if (!url) return;

    const urlToBase64 = async (url) => {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    urlToBase64(url).then(setBase64).catch(console.error);
  }, [url]);

  if (!base64) return <Skeleton height={60} width={100} />;

  return (
    <img
      src={base64}
      alt="signature"
      width={200}
      style={{ display: "block" }}
    />
  );
};

const CommonTableHeader = ({
  staffs,
  selectedClient,
  monthValue,
  getInitials,
  isExcel,
  taskType,
}) => {
  const { classes } = useStyles();
  const { allSignature } = useSelector((state) => state?.signature);

  return (
    <tbody style={{ display: isExcel ? "none" : "" }}>
      <tr>
        <td></td>
        {staffs
          ?.filter((_v) => _v && _v.id)
          ?.map(({ id }, index) => {
            return (
              <React.Fragment key={index}>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#1D2939", color: "#FFF" }}
                >
                  <Text fw={700} w={"100px"}>
                    Staff Name
                  </Text>
                </td>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#1D2939", color: "#FFF" }}
                >
                  <Text fw={700} w={"100px"}>
                    Initial
                  </Text>
                </td>
                <td
                  className={classes.bgCellColor}
                  style={{ background: "#1D2939", color: "#FFF" }}
                >
                  <Text fw={700} w={"100px"}>
                    Signature
                  </Text>
                </td>
              </React.Fragment>
            );
          })}
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        {staffs
          ?.filter((_v) => _v && _v.id)
          ?.map(({ name, id }) => {
            const staffSignature = allSignature?.find(
              ({ staff, admin }) =>
                (staff && staff?.id === id) || (admin && admin?.id === id),
            );
            return (
              <>
                <td>
                  <Text fw={400}>{name}</Text>
                </td>
                <td>{getInitials(name, id)}</td>
                <td>
                  {staffSignature?.signature ||
                  staffSignature?.signatureImage ? (
                    isExcel ? (
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={
                            decrypt(staffSignature?.signature) ||
                            decrypt(staffSignature?.signatureImage)
                          }
                          width="50"
                          height="50"
                          style={{
                            display: "block",
                            objectFit: "cover",
                          }}
                          alt="logo"
                          crossOrigin="anonymous"
                        />
                      </div>
                    ) : (
                      <SignatureImage
                        url={
                          decrypt(staffSignature?.signature) ||
                          decrypt(staffSignature?.signatureImage)
                        }
                      />
                    )
                  ) : staffSignature?.signatureText ? (
                    <Text fz={28} fw={400} ff="Island Moments" color="#171717">
                      {staffSignature?.signatureText}
                    </Text>
                  ) : (
                    "none"
                  )}
                </td>
              </>
            );
          })}
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700} w={"100px"}>
            Resident Name
          </Text>
        </td>
        <td>
          <Text>{selectedClient?.name}</Text>
        </td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700} w={"100px"}>
            Sex
          </Text>
        </td>
        <td>
          <Text w={"100px"}>{selectedClient?.form1?.gender}</Text>
        </td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700} w={"100px"}>
            DOB
          </Text>
        </td>
        <td>{moment(selectedClient?.form1?.dob).format("MM/DD/YYYY")}</td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700} w={"100px"}>
            Today's Date
          </Text>
        </td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700}>Allergies</Text>
        </td>
        <td>
          {selectedClient?.form1?.knownAllergies
            ?.map((item) => item)
            .join(", ") || "None"}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700}>Admission Date</Text>
        </td>
        <td>
          {moment(selectedClient?.form1?.admissionDate).format("MM/DD/YYYY")}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700} w={"100px"}>
            Current Month
          </Text>
        </td>
        <td>{new Date().toLocaleString("default", { month: "long" })}</td>
        <td>{moment().format("MM/DD/YYYY")}</td>
      </tr>
      <tr>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700}>Report Month</Text>
        </td>
        <td>
          {monthValue
            ?.map((item) =>
              moment(item).isValid() ? moment(item).format("MMM YYYY") : "",
            )
            .join(" - ")}
        </td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700}>Task Type</Text>
        </td>
        <td>{taskType}</td>
        <td className={classes.bgCellColor} style={{ background: "#1D2939", color: "#FFF" }}>
          <Text fw={700}>Current Year</Text>
        </td>
        <td>{new Date().getFullYear()}</td>
        <td></td>
      </tr>
    </tbody>
  );
};

/* ═══════════════════════════════════════════════════════════════════════
   ExcelFullTable — single <table> with ALL header info + matrix for XLS
   ReactHTMLTableToExcel grabs one table by ID, so everything must be rows.
   ═══════════════════════════════════════════════════════════════════════ */
const ExcelFullTable = ({
  data,
  datesArray,
  monthValue,
  selectedClient,
  staffs,
  getInitials,
  facilityName: facilityNameProp,
  taskTypeName: taskTypeNameProp,
}) => {
  const totalCols = 2 + (datesArray?.length || 0);
  const facName = facilityNameProp || selectedClient?.facility?.name || data?.[0]?.facility?.name || "Facility";
  const taskTypeName = taskTypeNameProp || (typeof data?.[0]?.taskType === "string" ? data[0].taskType : (data?.[0]?.taskType?.name || "Task Report"));

  return (
    <table id="excelTaskTable" style={{ borderCollapse: "collapse" }}>
      <tbody>
        {/* Row 1 — Facility name + report title */}
        <tr>
          <td colSpan={2} style={{ fontWeight: 700, fontSize: 16 }}>{facName}</td>
          <td colSpan={totalCols - 2} style={{ fontWeight: 700, fontSize: 14, textAlign: "right" }}>Monthly {taskTypeName} Report</td>
        </tr>
        {/* Row 2 — Subtitle + generated date */}
        <tr>
          <td colSpan={2} style={{ fontSize: 10, color: "#6B7280" }}>Monthly {taskTypeName} Report</td>
          <td colSpan={totalCols - 2} style={{ fontSize: 10, color: "#6B7280", textAlign: "right" }}>
            {moment(monthValue?.[0]).format("MMMM YYYY")} · Generated {moment().format("MM/DD/YYYY")}
          </td>
        </tr>
        {/* Spacer */}
        <tr><td colSpan={totalCols}></td></tr>

        {/* Client info header row */}
        <tr style={{ background: "#F9FAFB" }}>
          <td style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Resident Name</td>
          <td style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Date of Birth</td>
          <td colSpan={Math.floor((totalCols - 4) / 2)} style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Admission Date</td>
          <td colSpan={totalCols - 2 - Math.floor((totalCols - 4) / 2)} style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Allergies</td>
        </tr>
        <tr>
          <td>{selectedClient?.name || "—"}</td>
          <td>{selectedClient?.form1?.dob ? moment(selectedClient.form1.dob).format("MM/DD/YYYY") : "—"}</td>
          <td colSpan={Math.floor((totalCols - 4) / 2)}>
            {selectedClient?.form1?.admissionDate ? moment(selectedClient.form1.admissionDate).format("MM/DD/YYYY") : selectedClient?.form1?.admissiondate ? moment(selectedClient.form1.admissiondate).format("MM/DD/YYYY") : "—"}
          </td>
          <td colSpan={totalCols - 2 - Math.floor((totalCols - 4) / 2)}>{selectedClient?.form1?.knownAllergies?.join(", ") || "None"}</td>
        </tr>
        {/* Client info row 2 */}
        <tr style={{ background: "#F9FAFB" }}>
          <td style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Sex</td>
          <td style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Task Type</td>
          <td colSpan={Math.floor((totalCols - 4) / 2)} style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Report Month</td>
          <td colSpan={totalCols - 2 - Math.floor((totalCols - 4) / 2)} style={{ fontWeight: 600, fontSize: 9, textTransform: "uppercase", color: "#6B7280" }}>Report Date</td>
        </tr>
        <tr>
          <td>{selectedClient?.form1?.gender || "—"}</td>
          <td>{taskTypeName}</td>
          <td colSpan={Math.floor((totalCols - 4) / 2)}>{monthValue?.map((item) => moment(item).isValid() ? moment(item).format("MMM YYYY") : "").join(" – ")}</td>
          <td colSpan={totalCols - 2 - Math.floor((totalCols - 4) / 2)}>{moment().format("MM/DD/YYYY")}</td>
        </tr>
        {/* Spacer */}
        <tr><td colSpan={totalCols}></td></tr>

        {/* Staff header */}
        <tr>
          {staffs?.filter((_v) => _v && _v.id)?.map((_, idx) => (
            <React.Fragment key={idx}>
              <td style={{ fontWeight: 700, background: "#1D2939", color: "#FFF" }}>Staff Name</td>
              <td style={{ fontWeight: 700, background: "#1D2939", color: "#FFF" }}>Initial</td>
            </React.Fragment>
          ))}
          {/* Fill remaining cols */}
          {totalCols - (staffs?.filter((_v) => _v && _v.id)?.length || 0) * 2 > 0 && (
            <td colSpan={totalCols - (staffs?.filter((_v) => _v && _v.id)?.length || 0) * 2}></td>
          )}
        </tr>
        {/* Staff data */}
        <tr>
          {staffs?.filter((_v) => _v && _v.id)?.map(({ name, id }, idx) => (
            <React.Fragment key={idx}>
              <td>{name}</td>
              <td>{getInitials(name, id, true)}</td>
            </React.Fragment>
          ))}
          {totalCols - (staffs?.filter((_v) => _v && _v.id)?.length || 0) * 2 > 0 && (
            <td colSpan={totalCols - (staffs?.filter((_v) => _v && _v.id)?.length || 0) * 2}></td>
          )}
        </tr>
        {/* Spacer */}
        <tr><td colSpan={totalCols}></td></tr>

        {/* Day-of-week header row */}
        <tr style={{ background: "#1D2939", color: "#FFF" }}>
          <td></td>
          <td style={{ fontWeight: 600 }}>Task</td>
          {datesArray?.map((date, index) => (
            <td key={index} style={{ textAlign: "center", fontWeight: 600 }}>{date.format("ddd")}</td>
          ))}
        </tr>
        {/* Day number header row */}
        <tr style={{ background: "#F3F4F6" }}>
          <td style={{ fontWeight: 600 }}>Item</td>
          <td style={{ fontWeight: 600 }}>Task</td>
          {datesArray?.map((date, index) => (
            <td key={index} style={{ textAlign: "center", fontWeight: 600 }}>{date.format("DD")}</td>
          ))}
        </tr>

        {/* Matrix data rows */}
        {data?.map((_task, i) => (
          <React.Fragment key={i}>
            {_task?.fields?.map((_field, index) => (
              <tr key={index}>
                {index === 0 && (
                  <td
                    rowSpan={_task?.fields?.length}
                    style={{ fontWeight: 600, textTransform: "uppercase", background: "#1D2939", color: "#FFF" }}
                  >
                    {_task?.taskName || "-"}
                  </td>
                )}
                <td>{_field?.name || "-"}</td>
                {datesArray?.map((date, dIndex) => {
                  const found = _field?.date_array?.find((x) =>
                    moment(x?.date).format("YYYY-MM-DD") === date.format("YYYY-MM-DD")
                  );
                  return (
                    <td key={dIndex}>
                      {found?.date && found?.fieldName === _field?.name
                        ? found?.isChecked?.map((_fc, fcIdx) => (
                            <span key={fcIdx}>
                              {getInitials(_fc?.staff?.name, _fc?.staff?.id, true)}
                              {_fc?.textField ? ` - ${_fc.textField}` : ""}
                              {fcIdx < found.isChecked.length - 1 ? ", " : ""}
                            </span>
                          ))
                        : ""}
                    </td>
                  );
                })}
              </tr>
            ))}
          </React.Fragment>
        ))}

        {/* Footer */}
        <tr><td colSpan={totalCols}></td></tr>
        <tr>
          <td colSpan={totalCols} style={{ fontSize: 10, color: "#9CA3AF" }}>{facName} · Confidential — Report generated by Ogiso</td>
        </tr>
      </tbody>
    </table>
  );
};

const TaskTableComponent = ({
  data,
  loading,
  daysArray,
  datesArray,
  monthValue,
  selectedClient,
  staffs,
  getInitials,
  isExcel = false,
  facilityName: facilityNameProp,
  facilityPhoto,
}) => {
  const { classes } = useStyles();
  const facName = facilityNameProp || selectedClient?.facility?.name || data?.[0]?.facility?.name || "Facility";
  return (
    <Box className={classes.tableContainer} style={{ fontFamily: "Inter, Helvetica, Arial, sans-serif" }}>
      {loading ? (
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      ) : (
        <>
          {/* ═══ BRANDED HEADER ═══ */}
          <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "16px 20px", borderBottom: "3px solid #FFAF4A" }}>
            <Box style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {facilityPhoto ? (
                <img src={facilityPhoto} alt="" crossOrigin="anonymous" style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
              ) : (
                <Box style={{ width: 36, height: 36, borderRadius: "50%", background: "#FFAF4A", display: "flex", justifyContent: "center", alignItems: "center", flexShrink: 0 }}>
                  <Text fw={700} fz={14} color="#000">{facName[0]}</Text>
                </Box>
              )}
              <Box>
                <Text fw={700} fz={14} color="#1D2939">{facName}</Text>
                <Text fz={10} color="#6B7280">Monthly {typeof data[0]?.taskType === "string" ? data[0].taskType : (data[0]?.taskType?.name || "Task")} Report</Text>
              </Box>
            </Box>
            <Box style={{ textAlign: "right" }}>
              <Text fz={10} color="#6B7280">{moment(monthValue?.[0]).format("MMMM YYYY")} · Generated {moment().format("MM/DD/YYYY")}</Text>
            </Box>
          </Box>

          {/* Client info card */}
          <Box style={{ padding: "12px 20px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #E5E7EB", fontSize: 11 }}>
              <tbody>
                <tr>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB", width: "25%" }}>Resident Name</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB", width: "25%" }}>Date of Birth</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB", width: "25%" }}>Admission Date</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB", width: "25%" }}>Allergies</td>
                </tr>
                <tr>
                  <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB", fontWeight: 500 }}>{selectedClient?.name || "—"}</td>
                  <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{selectedClient?.form1?.dob ? moment(selectedClient.form1.dob).format("MM/DD/YYYY") : "—"}</td>
                  <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{selectedClient?.form1?.admissionDate ? moment(selectedClient.form1.admissionDate).format("MM/DD/YYYY") : selectedClient?.form1?.admissiondate ? moment(selectedClient.form1.admissiondate).format("MM/DD/YYYY") : "—"}</td>
                  <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{selectedClient?.form1?.knownAllergies?.join(", ") || "None"}</td>
                </tr>
                <tr>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Sex</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Task Type</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Report Month</td>
                  <td style={{ padding: "4px 8px", background: "#F9FAFB", fontWeight: 600, color: "#6B7280", fontSize: 9, textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Report Date</td>
                </tr>
                <tr>
                  <td style={{ padding: "4px 8px" }}>{selectedClient?.form1?.gender || "—"}</td>
                  <td style={{ padding: "4px 8px" }}>{typeof data[0]?.taskType === "string" ? data[0].taskType : (data[0]?.taskType?.name || "Activities of Daily Living")}</td>
                  <td style={{ padding: "4px 8px" }}>{monthValue?.map((item) => moment(item).isValid() ? moment(item).format("MMM YYYY") : "").join(" – ")}</td>
                  <td style={{ padding: "4px 8px" }}>{moment().format("MM/DD/YYYY")}</td>
                </tr>
              </tbody>
            </table>
          </Box>

          {/* Staff table */}
          <Box style={{ padding: "0 20px 12px 20px" }}>
            <table style={{ borderCollapse: "collapse", fontSize: 11 }}>
              <thead>
                <tr>
                  {staffs?.filter((_v) => _v && _v.id)?.map((_, idx) => (
                    <React.Fragment key={idx}>
                      <td style={{ padding: "4px 8px", background: "#1D2939", color: "#FFF", fontWeight: 600, fontSize: 10, minWidth: 100 }}>Staff Name</td>
                      <td style={{ padding: "4px 8px", background: "#1D2939", color: "#FFF", fontWeight: 600, fontSize: 10, minWidth: 50 }}>Initial</td>
                      <td style={{ padding: "4px 8px", background: "#1D2939", color: "#FFF", fontWeight: 600, fontSize: 10, minWidth: 80 }}>Signature</td>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {staffs?.filter((_v) => _v && _v.id)?.map(({ name, id }, idx) => (
                    <React.Fragment key={idx}>
                      <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{name}</td>
                      <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{getInitials(name, id)}</td>
                      <td style={{ padding: "4px 8px", borderBottom: "1px solid #E5E7EB" }}>{getInitials(name, id, false)}</td>
                    </React.Fragment>
                  ))}
                </tr>
              </tbody>
            </table>
          </Box>

          {/* Matrix grid */}
          <Box className={classes.tableBody}>
            <Table id={isExcel ? "excelTaskTable" : "taskTable"} withColumnBorders>
              <thead>
                <tr className={classes.dateCells} style={{ background: "#1D2939", color: "#FFF" }}>
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {datesArray?.map((date, index) => {
                    const isToday = date.isSame(moment(), "day");
                    return (
                      <td key={index} className={classes.dateCellsContent} style={isToday ? { background: "#FFAF4A", color: "#000" } : {}}>
                        <Text fz={10}>{date.format("ddd")}</Text>
                      </td>
                    );
                  })}
                </tr>
                <tr className={classes.dateCells} style={{ background: "#1D2939", color: "#FFF" }}>
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {datesArray?.map((date, index) => {
                    const isToday = date.isSame(moment(), "day");
                    return (
                      <td key={index} className={classes.dateCellsContent} style={isToday ? { background: "#FFAF4A", color: "#000" } : {}}>
                        <Text fz={9}>{date.format("MM/DD/YYYY")}</Text>
                      </td>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#F3F4F6" }}>
                  <td style={{ fontWeight: 600, fontSize: 10, padding: "4px 6px" }}>Item</td>
                  <td style={{ fontWeight: 600, fontSize: 10, padding: "4px 6px" }}>Task</td>
                  {datesArray?.map((date, index) => {
                    const isToday = date.isSame(moment(), "day");
                    return (
                      <td key={index} style={isToday ? { background: "#FEF3C7" } : {}}>
                        <Text fw={600} fz={11}>{date.format("DD")}</Text>
                      </td>
                    );
                  })}
                </tr>

                {data?.map((_task, i) => (
                  <React.Fragment key={i}>
                    {_task?.fields?.map((_field, index) => {
                      return (
                        <tr key={index}>
                          {index === 0 && (
                            <td
                              rowSpan={index === 0 ? _task?.fields?.length : 0}
                              style={{ border: "1px solid #E5E7EB", background: "#1D2939", color: "#FFF", fontWeight: 600, fontSize: 10, textTransform: "uppercase", padding: "4px 8px", minWidth: 80 }}
                            >
                              {_task?.taskName || "-"}
                            </td>
                          )}
                          <td>{_field?.name || "-"}</td>
                          {datesArray?.map((date, dIndex) => {
                            const found = _field?.date_array?.find((x) =>
                              moment(x?.date).format("YYYY-MM-DD") === date.format("YYYY-MM-DD")
                            );
                            const isTodayCol = date.isSame(moment(), "day");
                            return (
                              <td key={dIndex} style={{ padding: found?.isChecked?.length > 0 ? "0" : "initial", background: isTodayCol ? "#FEF3C7" : undefined }}>
                                {found?.date && found?.fieldName == _field?.name
                                  ? found?.isChecked?.map((_fc, fcIdx) => (
                                      <Text key={fcIdx} style={{ borderBottom: fcIdx === found?.isChecked?.length - 1 || !found?.isChecked?.length > 1 ? "none" : "1px solid #ccc", padding: 5 }}>
                                        {getInitials(_fc?.staff?.name, _fc?.staff?.id, isExcel)}
                                        {_fc?.textField ? ` - ${_fc.textField}` : ""}
                                      </Text>
                                    ))
                                  : ""}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Box>

          {/* Footer */}
          <Box style={{ display: "flex", justifyContent: "space-between", padding: "8px 20px", borderTop: "1px solid #E5E7EB" }}>
            <Text fz={10} color="#9CA3AF">{facName} · Confidential — Report generated by Ogiso</Text>
          </Box>
        </>
      )}
    </Box>
  );
};

const PDFTaskTableComponent = ({
  data,
  loading,
  daysArray,
  datesArray,
  selectedClient,
  monthValue,
  staffs,
  getInitials,
  facilityName: facilityNameProp,
  facilityPhoto,
  allSignature,
  decryptFn,
  taskTypeName: taskTypeNameProp,
}) => {
  const { classes } = useStyles();

  // Split datesArray into per-month groups
  const monthGroups = React.useMemo(() => {
    const map = {};
    const order = [];
    (datesArray || []).forEach((date) => {
      const key = date.format("YYYY-MM");
      if (!map[key]) {
        map[key] = [];
        order.push(key);
      }
      map[key].push(date);
    });
    return order.map((key) => ({ key, dates: map[key] }));
  }, [datesArray]);

  if (loading) {
    return (
      <Box className={classes.forPdfBox}>
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      </Box>
    );
  }

  if (!data?.length) return null;

  return (
    <>
      <Box
        className={classes.forPdfBox}
        data-pdf-month="all"
        data-facility-name={facilityNameProp || ""}
      >
        {monthGroups.map((group, idx) => (
          <MonthlyReportHtml
            key={group.key}
            data={data}
            datesArray={group.dates}
            selectedClient={selectedClient}
            monthValue={idx === 0 ? monthValue : [group.dates[0].toDate(), group.dates[group.dates.length - 1].toDate()]}
            staffs={staffs}
            getInitials={getInitials}
            facilityName={facilityNameProp}
            facilityPhoto={facilityPhoto}
            forPdf={true}
            pageOnly={idx !== 0}
            allSignature={allSignature}
            decryptFn={decryptFn}
            taskTypeName={taskTypeNameProp || data?.[0]?.taskType?.name}
          />
        ))}
      </Box>
    </>
  );
};

/*  OLD CODE REMOVED — PDFTaskTableComponent now uses MonthlyReportHtml */
const useStyles = createStyles((theme) => ({
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "70vh",
  },
  reportMonth: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
  },
  greenBox: {
    width: "15px",
    height: "15px",
    background: "#4fa80d",
  },
  exportBtn: {
    display: "flex",
    justifyContent: "end",
    padding: "1rem",
    alignItems: "center",
    gap: "1rem",
    // width: "1320px",
  },
  tableContainer: {
    border: "1px solid #EDEDED",
    width: "1320px",
  },
  forPdfBox: {
    width: "1400px",
    position: "absolute",
    left: "-9999px",
  },
  clientDetails: {
    display: "flex",
    alignItems: "start",
    gap: ".5rem",
    justifyContent: "start",
    padding: "1rem",
  },
  cuationsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: ".5rem",
    flexDirection: "column",
  },
  tableBodyBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: ".5rem",
    width: "100%",
  },
  bgCellColor: {
    background: "#1D2939",
    color: "#FFF",
  },
  dateCells: {
    backgroundColor: "#1D2939",
    color: "#FFF",
    border: "unset",
  },
  bgTitleColor: {
    background: "#ffff00",
    width: "200px",
  },
  medTitleCell: {
    width: "200px",
  },
  tableHeader: {
    width: "100%",
  },
  tableBody: {
    overflowX: "scroll",
    "& table": {
      width: "500px",
      "& tr:nth-child(1) td": {
        fontSize: "12px !important",
        fontWeight: "400 !important",
        textAlign: "center",
      },
      "& tr:nth-child(2) td": {
        fontSize: "10px !important",
        fontWeight: "300 !important",
        textAlign: "center",
      },
    },
  },
  dateCellsContent: {
    borderTop: "none !important",
    borderRight: "none !important",
  },
}));

export default TaskViewReportModal;
